const breakpoints = {
  xs: 'only screen and (min-width: 320px)',
  sm: 'only screen and (min-width: 576px)',
  md: 'only screen and (min-width: 768px)',
  lg: 'only screen and (min-width: 992px)'
}

export default breakpoints
